<div class="d-flex justify-content-center">
    <carousel class="w-100 imagens-carousel" [midias]="midias_listar"></carousel>
</div>
